import { observable } from "mobx";

import {
  apiGetPhysicians,
  PermissionBit,
  PhysicianWithPatientsResponse,
} from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export class Physicians extends DataModel<PhysiciansItem> {
  readonly idAttr = "uuid";
  @observable accessor loading = false;

  constructor(
    data: PhysiciansItem[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);

    // access
    this.access = {
      editRules: {
        medical: AccessRules.owner,
        monitoring: AccessRules.visible,
      },
      deleteRules: {
        medical: AccessRules.none,
        monitoring: AccessRules.visible,
      },
      historyRequiresMonitoring: false,
    };
  }
}

export async function loadPhysicians(model: Physicians) {
  model.loading = true;
  try {
    const res = await apiGetPhysicians();
    model.data = res.data.physicians.map(toPhysiciansItem);
    model.init();
  } finally {
    model.loading = false;
  }
}

export function toPhysiciansItem(
  data: PhysicianWithPatientsResponse,
): PhysiciansItem {
  const numClinics = data.clinics?.length ?? 0;
  const clinics =
    data.clinics
      ?.map((obj) => `${obj["name"]} (${obj["ambulance"]})`)
      .join(" \\ ") ?? "";
  const numPatients = data.patients?.length ?? 0;
  const username = data.connected_user?.username ?? "";
  const monitoringUserNames =
    data.assigned_monitoring_users?.map((user) => user.username) ?? [];
  return {
    ...data,
    ["numClinics"]: numClinics,
    ["clinicsStr"]: clinics,
    ["numPatients"]: numPatients,
    ["username"]: username,
    ["monitoringUserNames"]: monitoringUserNames,
  };
}

export interface PhysiciansItem extends PhysicianWithPatientsResponse {
  numClinics: number;
  clinicsStr: string;
  numPatients: number;
  username: string;
  monitoringUserNames: string[];
}
